module.exports = __webpack_public_path__ + "43ca7af0a33ef2a2f23a4a3f26fba827.svg";